import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 5em 0;
    background-color: #FFFFFF;

    .article-boxes {
        margin: 3em 0;
        display: grid;
        grid-template-columns: repeat(3,1fr);
        gap: 2em 1em;
    }

    .layout-button {
        padding-top: 2.5em;
    }

    .layout-pagination {
        ul {
            padding: 0;
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
        padding-top: 0;

        .article-boxes {
           grid-template-columns: repeat(2,1fr);
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .article-boxes {
            grid-template-columns: 1fr;
            padding: 0 2em;

            .public-layout-articles-medium-article-box {
                max-width: 100%;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        padding: 0;

        .article-boxes {
            .public-layout-articles-medium-article-box {
                min-height: 0;
            }
        }
    }
`;